import {Component, computed, effect, inject, input, OnInit, viewChild} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {PageGridComponent} from '../../../shared/components/page-grid/page-grid.component';
import {GridEventOutput, GridModel} from '../../../shared/model/page-grid';
import {KtCogsFilterService} from '../../service/kt-cogs-filter.service';
import {KtCogsGridService} from '../../service/kt-cogs-grid.service';
import {IKtCogsListItem} from '../../interfaces/kt-trip.interface';
import {KtCogsDetailModalComponent} from '../kt-cogs-detail-modal/kt-cogs-detail-modal.component';

@Component({
  selector: 'app-kt-cogs-list',
  templateUrl: './kt-cogs-list.component.html',
  standalone: false,
})
export class KtCogsListComponent implements OnInit {
  private readonly filterService = inject(KtCogsFilterService);
  private readonly gridService = inject(KtCogsGridService);
  private readonly dialog = inject(MatDialog);

  readonly salesOrderId = input<number | null>(null);

  protected readonly gridRef = viewChild.required(PageGridComponent);

  protected readonly gridConfig = computed<GridModel<IKtCogsListItem>>(() => ({
    gridDataTestId: 'kt-cogs-list',
    gridTitle: 'COGS',
    defaultPageSize: 25,
    columns: [
      {
        columnProperty: 'id',
        columnHeader: 'COGS ID',
        sort: true,
        clickable: true,
        linkEventFunction: (item: IKtCogsListItem) => `/KtCogs/${item.id}`,
      },
      ...(!this.salesOrderId() ? [{
        columnProperty: 'tripReference',
        columnHeader: 'Trip Reference',
        sort: true,
        textLeft: true,
      }] : []),
      {
        columnProperty: 'vendorName',
        columnHeader: 'Vendor',
        sort: true,
        textLeft: true,
      },
      {
        columnProperty: 'vendorInterfaceId',
        columnHeader: 'Vendor Interface ID',
        sort: false,
        textLeft: true,
      },
      {
        columnProperty: 'providerVendorName',
        columnHeader: 'Provider',
        sort: true,
        textLeft: true,
      },
      {
        columnProperty: 'confirmationNumber',
        columnHeader: 'Confirmation Number',
        sort: true,
        textLeft: true,
      },
      {
        columnProperty: 'subVendorName',
        columnHeader: 'Sub-Vendor',
        sort: false,
        textLeft: true,
      },
      {
        columnProperty: 'subVendorInterfaceId',
        columnHeader: 'Sub-Vendor Interface ID',
        sort: false,
        textLeft: true,
      },
      {
        columnProperty: 'subVendorLegalEntity',
        columnHeader: 'Sub-Vendor Legal Entity',
        sort: false,
        textLeft: true,
      },
      {
        columnProperty: 'commissionAgencyName',
        columnHeader: 'Tour Agency',
        sort: false,
        textLeft: true,
      },
      {
        columnProperty: 'commissionAgencyParentName',
        columnHeader: 'Tour Agency Parent',
        sort: false,
        textLeft: true,
      },
      {
        columnProperty: 'productTypeName',
        columnHeader: 'Product Type',
        sort: true,
      },
      {
        columnProperty: 'amount',
        columnHeader: 'Amount',
        sort: false,
      },
      {
        columnProperty: 'amountUSD',
        columnHeader: 'Amount USD',
        sort: false,
      },
      {
        columnProperty: 'currencyCode',
        columnHeader: 'Currency',
        sort: false,
      },
    ],
    gridGetService: this.gridService,
  }));

  public ngOnInit(): void {
    if (this.salesOrderId()) {
      this.gridService.salesOrderId = this.salesOrderId();
    }
  }

  constructor() {
    effect(() => {
      const filters = this.filterService.filtersValue();
      if (!filters.ReloadGrid) return;
      this.gridRef().getItems();
    });
  }

  protected handleColumnClick(event: GridEventOutput<IKtCogsListItem>): void {
    if (event.column === 'id') {
      this.dialog.open(KtCogsDetailModalComponent, {
        width: '65%',
        data: {id: event.item.id},
      });
    }
  }
}
